import * as Turbo from "@hotwired/turbo"
import "flowbite"
import "flowbite/dist/flowbite.turbo.js"

Turbo.start()
